/* eslint-disable @typescript-eslint/no-explicit-any */
import * as actions from "../actions";
import * as requests from "../../../requests/localization/requestCreators";

import { EwaThunk } from "../../types";
import { LangCode } from "../../../requests/localization/types";

const requestLanguageChange =
  (langCode: LangCode): EwaThunk =>
  async (dispatch, getState) => {
    dispatch(actions.ChangeLanguage());
    try {
      await requests.changeLanguage(langCode);

      dispatch(actions.SuccessChangeLanguage(langCode));

      window.location.reload();
    } catch (e) {
      if (!(e as any).response) console.error(e);
      dispatch(actions.ErrorChangeLanguage((e as any).response));
    }
  };

export default requestLanguageChange;
